import React, { useEffect, useState } from "react";
import { useDebounce } from "use-debounce";
import classnames from "classnames";
import { FloatingLabel, Form } from "react-bootstrap";

export default function InputColor({
  label,
  value,
  onChange,
  maxWidth,
  className,
  ...params
}) {
  const [color, setColor] = useState(value);
  const [inputColor] = useDebounce(color, 300);

  useEffect(() => {
    onChange(inputColor);
  }, [inputColor]);

  useEffect(() => {
    setColor(value);
  }, [value]);

  const handleSetColor = (e) => {
    const inputValue = e.target.value;
    const hexColorRegex = /^#[A-Fa-f0-9]{0,6}$/;
    if (hexColorRegex.test(inputValue) || inputValue === "") {
      setColor(e.target.value);
    }
  };

  return (
    <FloatingLabel
      label={label}
      className={classnames("position-relative", {
        "mb-3": !className,
        [className]: className,
      })}
      style={maxWidth ? { maxWidth: `${maxWidth}px` } : {}}
    >
      <Form.Control
        value={color}
        className={classnames("w-100 text-uppercase", {
          "pt-3": !label,
        })}
        onChange={handleSetColor}
      />
      <div className="position-absolute top-0 end-0 d-flex align-items-center justify-content-center rounded-1 p-2 h-100">
        <label
          className="rounded-1 border border-1"
          style={{ backgroundColor: color, width: "36px", height: "36px" }}
        >
          <input
            className="opacity-0"
            style={{ width: 0, height: 0 }}
            type="color"
            onChange={(e) => setColor(e.target.value)}
            value={color}
            {...params}
          />
        </label>
      </div>
    </FloatingLabel>
  );
}
